import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import { installFetchTracing } from "./lib/observability/installFetchTracing";
import App from "./App.tsx";
import "./index.css";

// Stamp every backend call with correlation headers, then initialize Sentry — both before
// React renders so the very first request and any early error already carry the session id.
installFetchTracing();
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
  